import axios from "axios";
import config from "../config";
const search = async (queryString, env, elastic_index) => {
    try {
        const lang = typeof a3_lang !== "undefined"
            ? a3_lang
            : document.getElementsByTagName("html")[0].getAttribute("lang");
        const response = await axios.post(`${config.api_url[env]}/api-elastic/${elastic_index}/search/${env}-*/_search`, {
            queryString,
            env,
            elastic_index,
            lang,
        });
        console.log(JSON.stringify({
            queryString,
            env,
            elastic_index,
            lang,
        }));
        return response.data;
    }
    catch (exc) {
        console.log(exc);
    }
};
export { search };
